/*
 * Build flag for the ticket-transfer surface (PROJ-0078-WU-10, design note
 * docs/current/DESIGN-TRANSFER-RECIPIENT-STEP-V1.md, boardroom dispatch
 * BOARDROOM-2026-09-27-191409). Same shape as Shell's arabicToggleEnabled:
 * the feature renders ONLY when VITE_TRANSFER_ENABLED === 'true' — absent or
 * anything else = OFF, which is correct for stage and prod with zero env
 * changes until tickets ships TRANSFER_HOLD_LIVE + the caller-model contract.
 * The env is injectable so tests can pin both sides.
 */
export function transferEnabled(env: Record<string, string | undefined> = import.meta.env): boolean {
  return env.VITE_TRANSFER_ENABLED === 'true'
}
